import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';

const styles = {
  welcomeArea: {
    height: '900px',
    position: 'relative',
    zIndex: '1',
    backgroundPosition: 'bottom center',
    backgroundSize: 'cover',
    background: 'linear-gradient( 90deg, #334956 0%, #334956 100%)',
    clipPath: 'ellipse(100% 85% at 12% 13%)',
  },
  container: {
    maxWidth: '1140px',
    width: '100%',
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  fullHeight: {
    height: '100%',
  },
  alignCenter: {
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '-15px',
    marginLeft: '-15px',
  },
  clearfix: {
    display: 'block',
    clear: 'both',
    content: '',
  },
  welcomeInfo: {
    flexBasis: '0',
    flexGrow: '1',
    maxWidth: '100%',
    position: 'relative',
    width: '100%',
    minHeight: '1px',
    paddingRight: '15px',
    paddingLeft: '15px',
  },
  welcomHeading: {
    marginBottom: '100px',
  },
  welcomeTitle: {
    fontSize: '100px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    color: '#ffffff',
    fontWeight: 'bold',
    position: 'relative',
    zIndex: '3',
    alignItems: 'center',
    display: 'block',
    marginBottom: '30px',
    textShadow: '-1px -1px 0 #273846, 1px -1px 0 #273846, -1px 1px 0 #273846, 1px 1px 0 #273846',
  },
  welcomePlaceholder: {
    fontSize: '332px',
    position: 'absolute',
    top: '-47px',
    fontWeight: '800',
    left: '0',
    margin: '0',
    zIndex: '-1',
    color: '#fff',
    opacity: '.1',
  },
  welcomeDesc: {
    fontSize: '35px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    marginTop: '0',
    color: '#fff',
    textShadow: '-1px -1px 0 #273846, 1px -1px 0 #273846, -1px 1px 0 #273846, 1px 1px 0 #273846',

  },
  welcomeImgCont: {
    overflow: 'visible',
    height: '500px',
    display: 'inline-block',
    position: 'absolute',
    top: '250px',
    right: '40px',
  },
  welcomeImg: {
    height: '450px',
    transform: 'scale(1.25, 1.15) translate(-20%, -5%)',
  },
};
class WelcomeSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <section className={classNames(classes.welcomeArea, classes.clearfix)} id="home">
        <div className={classNames(classes.container, classes.fullHeight)}>
          <Slide direction="down" in mountOnEnter unmountOnExit>
            <div className={classes.welcomeImgCont} data-wow-delay="1s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInDown' }}>
              <img className={classes.welcomeImg} src={require('./shutterstock_334442948.png')} alt="" />
            </div>
          </Slide>
          <div className={classNames(classes.fullHeight, classes.alignCenter, classes.row)}>
            <div className={classes.welcomeInfo}>
              <div className={classes.welcomHeading}>
                <h2 className={classes.welcomeTitle}>Platform Ops Portal</h2>
                <h3 className={classes.welcomePlaceholder}>POP</h3>
                <p className={classes.welcomeDesc}>Welcome to 555 Administrator Portal</p>
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default withStyles(styles)(WelcomeSection);
